/** @jsx jsx */
import * as React from "react";
import { css, jsx } from "@emotion/core";
import { IFetchScheduledInterventionsProgresssResponse } from "../../models/IFetchScheduledInterventions";
import { interventionsSummaryStyles } from "../../styles/Interventions/interventionsSummary";
import { ISugarJournalResponse } from "../../models/ISugarJournalResponse";
import { data } from "jquery";
import { Card } from "../common/Card";




interface ISugarJournalProps {
    data: ISugarJournalResponse[];
}

enum TIME_OPTIONS {
    WEEK = "WEEK",
    ALL_TIME = "ALL_TIME",
    CUSTOM_DATE = "CUSTOM_DATE"
}

interface ISugarJournalState {
    selectedTimeOption: TIME_OPTIONS;
    isDateRangePickerVisible: boolean;
}


export class SugarJournalSummary extends React.Component<ISugarJournalProps, ISugarJournalState> {
    constructor(props: ISugarJournalProps) {
        super(props);
        this.state = {
            selectedTimeOption: TIME_OPTIONS.WEEK,
            isDateRangePickerVisible: false
        };

    }

    getKpiData(data: ISugarJournalResponse[]) {
        const kpiData = {
            veryHigh: 0,
            high: 0,
            normal: 0,
            low: 0,
            veryLow: 0,
            total: 0
        };

        if (data && data.length) {
            kpiData.total = data.length;
            data.forEach(({ rangeLabel }) => {
                if (rangeLabel === "MODERATE") {
                    kpiData.normal = kpiData.normal + 1;
                } else if (rangeLabel === "LOW") {
                    kpiData.low = kpiData.low + 1;
                } else if (rangeLabel === "VERY_LOW") {
                    kpiData.veryLow = kpiData.veryLow + 1;
                } else if (rangeLabel === "HIGH") {
                    kpiData.high = kpiData.high + 1;
                } else if (rangeLabel === "CRITICAL") {
                    kpiData.veryHigh = kpiData.veryHigh + 1;
                }
            })
        }


        return kpiData;
    }

    render() {
        const { data } = this.props;
        const { total, high, veryHigh, normal, low, veryLow } = this.getKpiData(data);
        return (<div css={interventionsSummaryStyles.summaryCardWrapper}>
            <Card customCss={{ borderRadius: 10 }} showShadow>
                <div css={{ ...interventionsSummaryStyles.summaryContainer as any, minHeight: 133 }}>
                    <div css={interventionsSummaryStyles.cardHeaderText}>Summary</div>
                    <div css={interventionsSummaryStyles.kpiContainer}>
                        <div>
                            <div css={interventionsSummaryStyles.kpiBoldText}>{total}</div>
                            <div css={interventionsSummaryStyles.kpiSmallText}>Total Readings</div>
                        </div>
                        <div>
                            <div><span css={interventionsSummaryStyles.kpiBoldText}>{veryHigh}</span>/<span css={interventionsSummaryStyles.kpiSmallText}>{total}</span></div>
                            <div css={interventionsSummaryStyles.kpiSmallText}>Very High</div>
                        </div>
                        <div>
                            <div><span css={interventionsSummaryStyles.kpiBoldText}>{high}</span>/<span css={interventionsSummaryStyles.kpiSmallText}>{total}</span></div>
                            <div css={interventionsSummaryStyles.kpiSmallText}>High</div>
                        </div>
                        <div>
                            <div><span css={interventionsSummaryStyles.kpiBoldText}>{normal}</span>/<span css={interventionsSummaryStyles.kpiSmallText}>{total}</span></div>
                            <div css={interventionsSummaryStyles.kpiSmallText}>Normal</div>
                        </div>
                        <div>
                            <div><span css={interventionsSummaryStyles.kpiBoldText}>{low}</span>/<span css={interventionsSummaryStyles.kpiSmallText}>{total}</span></div>
                            <div css={interventionsSummaryStyles.kpiSmallText}>Low</div>
                        </div>
                        <div>
                            <div><span css={interventionsSummaryStyles.kpiBoldText}>{veryLow}</span>/<span css={interventionsSummaryStyles.kpiSmallText}>{total}</span></div>
                            <div css={interventionsSummaryStyles.kpiSmallText}>Very Low</div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>)
    }
}